import React from 'react';
export function ArrowIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-127">
      <line x1="5" y1="12" x2="19" y2="12" data-id="element-128" />
      <polyline points="12 5 19 12 12 19" data-id="element-129" />
    </svg>;
}